<script setup lang="ts">
import { useApi } from '~/composables/useApi';

const { data: system } = await useApi().get<{ release: string | null }>('/system/info');
const links = [
  {
    label: 'footer.nav.impress',
    to: 'https://opebo.de/impressum',
  },
  {
    label: 'footer.nav.privacy',
    to: `https://opebo.de/privacy-policy`,
  },
  {
    label: 'footer.nav.contact',
    to: '/contact',
  },
  {
    label: 'footer.nav.agb',
    to: 'https://opebo.de/agb',
  },
  {
    label: 'nav.main.profile.cookieConsent',
    icon: 'ic:outline-cookie',
    to: '/cookies',
  },
];
</script>
<template>
  <UContainer class="w-full">
    <USeparator class="my-4 text-sm text-dimmed" icon="i-heroicons-home" :label="'opebo ©2024, release ' + (system?.release ?? 'dev')"
      ><TextBrand :title="'release ' + (system?.release ?? 'dev')" /><span class="text-dimmed"
        >&nbsp;©&nbsp;2026, All Rights Reserved.</span
      ></USeparator
    >
    <UNavigationMenu :items="links" class="mt-4 mb-4 justify-center" :ui="{ list: 'flex flex-wrap justify-center' }">
      <template #item="{ item }">
        <UIcon v-if="item.icon" :name="item.icon" class="" />
        <span class="relative">{{ $t(item.label) }}</span>
      </template>
    </UNavigationMenu>
  </UContainer>
</template>
